import React, {useEffect, useState} from 'react';
import {
  ServicesNavContainer,
  MainConainter,
  Row,
  Col6Left,
  Col6Right,
  ServiceActive,
  ServicesOperational,
  ServiceNavSelect,
  ServiceNavSelectOption,
} from './servicesNavStyles';

// Reads the `/en/es`-style value Google Translate's own cookie uses, so the
// dropdown shows the right selection on load (including after the reload
// triggered by a language change) without waiting on the translate widget
// itself to initialize.
const currentGoogTransLang = () => {
  const match = document.cookie.match(/(?:^|; )googtrans=\/en\/([a-z]{2})/)
  return match ? match[1] : 'en'
}

const loadGoogleTranslateScript = () => {
  if (window.googleTranslateScriptLoaded) return
  window.googleTranslateScriptLoaded = true

  window.googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {pageLanguage: 'en', includedLanguages: 'en,es', autoDisplay: false},
      'google_translate_element'
    )
  }

  const script = document.createElement('script')
  script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
  document.body.appendChild(script)
}

const ServicesNav = () => {
  const [language, setLanguage] = useState(currentGoogTransLang())

  useEffect(() => {
    loadGoogleTranslateScript()
  }, [])

  const onLanguageChange = (e) => {
    const lang = e.target.value
    setLanguage(lang)
    document.cookie = `googtrans=/en/${lang}; path=/`
    window.location.reload()
  }

  return (
    <ServicesNavContainer>
      <div id="google_translate_element" style={{display: 'none'}} />
      <MainConainter className='container'>
        <Row className='row'>
          <Col6Left className='col-6'>
            <ServiceActive />
            <ServicesOperational>All Services Operational</ServicesOperational>
          </Col6Left>
          <Col6Right className='col-6'>
            <ServiceNavSelect value={language} onChange={onLanguageChange}>
              <ServiceNavSelectOption value="en">English</ServiceNavSelectOption>
              <ServiceNavSelectOption value="es">Español</ServiceNavSelectOption>
            </ServiceNavSelect>
          </Col6Right>
        </Row>
      </MainConainter>
    </ServicesNavContainer>
  );
};

export default ServicesNav;
